import { TrackJS } from 'trackjs';
import MarketingClient from 'marketing-app-js-vendor';

import config from '@fr/config/appConfig';

const clientUuid = window.appConfig?.clientUuid;

if (!clientUuid) {
    TrackJS.track('No clientUuid provided!!');
}

let marketingClient = null;

try {
    marketingClient = new MarketingClient({
        config: config.marketingClientConfig,
        clientUuid,
    });
} catch (err) {
    TrackJS.track(err);
}

export default marketingClient;
